import { Calendar, ChevronRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

interface AvailabilitiesLinkCardProps {
  readonly apartmentId: string;
}

export const AvailabilitiesLinkCard = ({ apartmentId }: AvailabilitiesLinkCardProps) => {
  const { t } = useTranslation(['pages']);
  const navigate = useNavigate();

  return (
    <button
      onClick={() => navigate(`/apartments/${apartmentId}/availabilities`)}
      className="w-full flex items-center justify-between p-4 bg-white border border-gray-200 rounded-xl hover:bg-gray-50 transition-colors"
    >
      <div className="flex items-center gap-3">
        <div className="p-2 bg-accent-50 text-accent-600 rounded-lg">
          <Calendar size={20} />
        </div>
        <span className="font-medium text-gray-900">{t('pages:manageAvailabilities')}</span>
      </div>
      <ChevronRight size={20} className="text-gray-400" />
    </button>
  );
};

export default AvailabilitiesLinkCard;
